import { FormDataConsumer, TextInput, email, required, useTranslate } from "react-admin"
import FormCard from "../inputFormComponents/FormCard"
import FormRow from "../inputFormComponents/FormRow"
import { postCode } from "../validators/validate"

const FormCardCompany = () => {
  const translate = useTranslate()

  return (
    <FormCard title={translate('resources.company.name')} rows={[
      <FormRow fields={[
        <TextInput fullWidth helperText={false} source="company.companyName" label="resources.company.companyName" validate={required()} />
      ]}/>,
      <FormRow fields={[
        <TextInput fullWidth helperText={false} source="company.additionalAddress" label="resources.company.additionalAddress" />,
      ]} />,
      <FormRow fields={[
        <TextInput fullWidth helperText={false} source="company.street" label="resources.company.street" />,
      ]}/>,
      <FormRow fields={[
        <FormDataConsumer>
          {({formData, ...rest}) => 
            <TextInput 
              fullWidth 
              helperText={false} 
              source="company.postCode" 
              label="resources.company.postCode" 
              validate={
                !formData.company?.country
                || formData.company?.country === "" 
                || formData.company?.country === "Deutschland" 
                || formData.company?.country === "Germany" 
                ? [required(), postCode()] 
                : undefined
              } 
            />    
          }
        </FormDataConsumer>,
        <TextInput sx={{ml:2}} fullWidth helperText={false} source="company.city" label="resources.company.city" />,
        <TextInput sx={{ml:2}} fullWidth helperText={false} source="company.country" label="resources.company.country" />
      ]} />,
      <FormRow fields={[
        <TextInput fullWidth helperText={false} source="company.email" label="resources.company.email" validate={email()} />,
        <TextInput sx={{ml:2}} fullWidth helperText={false} source="ustId" label="resources.customers.ustId" />
      ]}/>
    ]} />
  )
}

export default FormCardCompany